import { RegionShared } from "@1games-ru/region-shared";
import { useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";
import rpc from "@1games-ru/rage-rpc";
import PlayerMpProvider from "@/core/data-provider/data-mp/player/player-mp-provider.ts";
import useAppDispatch from "@/core/helpers/useAppDispatch.ts";
import { imgHomeMenuPlayer } from "@/shared/assets/img";
import { clearOffer, setOfferResolver } from "@/domains/offer/slice.ts";
import toast from "@/domains/toasts/helpers/toast.ts";

export default () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation("offer");

  useLayoutEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.Offer.OfferResolverShow,
      async (state: typeof RegionShared.Cef.Requests.OfferResolverShowRequest): Promise<void> => {
        const character = await PlayerMpProvider.getCharacter(state.baseCharacterId);

        if (!character) {
          toast.error(t("offer.errors.CAN_NOT_FIND_CHARACTER"));
          console.error("Character not found");
          return;
        }

        dispatch(
          setOfferResolver({
            type: state.type,
            resolver: {
              uuid: state.uuid,
              targetId: state.targetId,
              price: state.amount,
              baseCharacter: {
                id: state.baseCharacterId,
                name: character.name.content,
                avatar: imgHomeMenuPlayer,
              },
            },
          }),
        );
      },
    );

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Offer.OfferResolverShow);
    };
  }, [dispatch, t]);

  useLayoutEffect(() => {
    rpc.register(RegionShared.Cef.Events.Offer.OfferResolverHide, async (): Promise<void> => {
      dispatch(clearOffer());
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Offer.OfferResolverHide);
    };
  }, [dispatch, t]);
};
